
import React from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function MayaTerminalSolutionDetails({
  terminalDetails,
  setTerminalDetails,
  terminalError,
  setTerminalError,
  TERMINAL_MODELS,
  REASON_NO_MID,
  handleTerminalChange,
  // Removed defective terminal props
  navigation,
}) {
  // Validation logic for terminal details only
  const validateTerminalSection = () => {
    const poaValue = parseFloat(terminalDetails.poa);
    const isPoaValid = !isNaN(poaValue) && poaValue >= 0;
    
    const errors = {
      terminal_available: !terminalDetails.terminal_available,
      poa: !terminalDetails.poa || !isPoaValid,
      // terminal_model: terminalDetails.terminal_model.length === 0,
      // serial_number: !terminalDetails.serial_number,
      // terminal_id: !terminalDetails.terminal_id,
      // card_efs: !terminalDetails.card_efs,
      // qr_efs: !terminalDetails.qr_efs,
      // not_obtaining_mid_reason: terminalDetails.not_obtaining_mid_reason.length === 0,
      // other_reason_no_mid:
      //   terminalDetails.not_obtaining_mid_reason.includes('Other reason') && !terminalDetails.other_reason_no_mid,
      // is_defective: !terminalDetails.is_defective,
    };
    setTerminalError(errors);

    const hasErrors = Object.values(errors).some(e => e);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleBack = () => {
     navigation.previous();
  };

  // Check if form is valid for visual feedback (without setting errors)
  const isFormValid = () => {
    const isValid = terminalDetails.terminal_available &&
                   terminalDetails.poa
                  //  terminalDetails.terminal_model.length > 0 &&
                  //  terminalDetails.card_efs &&
                  //  terminalDetails.qr_efs &&
                  //  terminalDetails.not_obtaining_mid_reason.length > 0 &&
                  //  terminalDetails.is_defective &&
                  //  (!terminalDetails.not_obtaining_mid_reason.includes('Other reason') || terminalDetails.other_reason_no_mid);
    return isValid;
  };

  const handleNext = () => {
    const validTerminal = validateTerminalSection();
    if (validTerminal) {
      navigation.go("working-terminal-details");
    }
  };


  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">MAYA TERMINAL SOLUTION DETAILS</h4>
                <p className="form-desc">Please provide Maya terminal solution information</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
              <Form>
                {/* At least one terminal available */}
                <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    At least one (1) Maya terminal is working and available <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Select
                    name="terminal_available"
                    value={terminalDetails.terminal_available || ""}
                    onChange={handleTerminalChange}
                    className={`form-input${
                      terminalError.terminal_available ? " form-input-error" : ""
                    }`}
                  >
                    <option value="">Select Option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                  {terminalError.terminal_available && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group>
                {/* Terminal Device Count */}
                <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Terminal Device Count (POA) <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    step="1"
                    name="poa"
                    value={terminalDetails.poa}
                    onChange={handleTerminalChange}
                    placeholder="Ex. 1"
                    isInvalid={terminalError.poa}
                  />
                  {terminalError.poa && (
                    <div className="form-error">
                      {!terminalDetails.poa ? 'Required' : 'Please enter a number greater than or equal to 0'}
                    </div>
                  )}
                </Form.Group>
                {/* Terminal Type */}
                {/* <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Terminal Type <span className="form-required">*</span>
                  </Form.Label>
                  <div className="form-checkbox-group">
                    {TERMINAL_MODELS.map((model, idx) => (
                      <div key={model} className={`form-checkbox-item${terminalDetails.terminal_model.includes(model) ? " selected" : ""}`}>
                        <div className="form-checkbox-flex">
                          <Form.Check
                            type="checkbox"
                            name="terminal_model"
                            value={model}
                            label={model}
                            checked={terminalDetails.terminal_model.includes(model)}
                            onChange={handleTerminalChange}
                            className="form-checkbox"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  {terminalError.terminal_model && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group> */}
                
                {/* Serial Number */}
                {/* <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Serial Number <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="serial_number"
                    value={terminalDetails.serial_number || ""}
                    onChange={handleTerminalChange}
                    placeholder="Enter serial number..."
                    className={`form-input${terminalError.serial_number ? " form-input-error" : ""}`}
                  />
                  {terminalError.serial_number && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group> */}

                {/* Terminal ID */}
                {/* <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Terminal ID <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="terminal_id"
                    value={terminalDetails.terminal_id || ""}
                    onChange={handleTerminalChange}
                    placeholder="Enter terminal ID..."
                    className={`form-input${terminalError.terminal_id ? " form-input-error" : ""}`}
                  />
                  {terminalError.terminal_id && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group> */}

                {/* Terminal MID (Card EFS) */}
                {/* <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Terminal MID (Card EFS) <span className="form-required">*</span>
                  </Form.Label> */}
                  {/* <Form.Text className="form-hint">
                    For multiple terminals, use a comma to separate the IDs. (Ex: 103759734, 104513887) Put N/A if not obtained
                  </Form.Text> */}
                   {/* <Form.Control
                    type="text"
                    name="card_efs"
                    value={terminalDetails.card_efs}
                    onChange={handleTerminalChange}
                    isInvalid={terminalError.card_efs}
                  />
                  {terminalError.card_efs && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group> */}
                {/* Terminal MID (QR EFS) */}
                 {/* <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Terminal MID (QR EFS) <span className="form-required">*</span>
                  </Form.Label>  */}
                  {/* <Form.Text className="form-hint">
                    For multiple terminals, use a comma to separate the IDs. (Ex: 103759734, 104513887) Put N/A if not obtained
                  </Form.Text> */}
                  {/* <Form.Control
                    type="text"
                    name="qr_efs"
                    value={terminalDetails.qr_efs}
                    onChange={handleTerminalChange}
                    isInvalid={terminalError.qr_efs}
                  />
                  {terminalError.qr_efs && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group> */}
                {/* cMID */}
                {/* <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Reason for not obtaining MID <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Select
                    name="not_obtaining_mid_reason"
                    value={terminalDetails.not_obtaining_mid_reason[0] || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleTerminalChange({
                        target: {
                          name: "not_obtaining_mid_reason",
                          value: value ? [value] : []
                        }
                      });
                    }}
                    className={`form-input${
                      terminalError.not_obtaining_mid_reason ? " form-input-error" : ""
                    }`}
                  >
                    <option value="">Select Reason</option>
                    {REASON_NO_MID.map((reason, idx) => (
                      <option key={`reason-${idx}`} value={reason}>
                        {reason}
                      </option>
                    ))}
                  </Form.Select>
                  {terminalError.not_obtaining_mid_reason && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group> */}
                {/* Other reason for not obtaining MID */}
                {/* {terminalDetails.not_obtaining_mid_reason.includes('Other reason') && (
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Other reason for not obtaining MID <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="other_reason_no_mid"
                      value={terminalDetails.other_reason_no_mid}
                      onChange={handleTerminalChange}
                      isInvalid={terminalError.other_reason_no_mid}
                    />
                    {terminalError.other_reason_no_mid && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>
                )} */}
                {/* Has defective terminal */}
                {/* <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Has Terminal Concern <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Select
                    name="is_defective"
                    value={terminalDetails.is_defective || ""}
                    onChange={handleTerminalChange}
                    className={`form-input${
                      terminalError.is_defective ? " form-input-error" : ""
                    }`}
                  >
                    <option value="">Select Option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                  {terminalError.is_defective && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group> */}
                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaTerminalSolutionDetails;
